import { ReactNode } from 'react';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { Col, Flex, Row } from 'antd';
import { TbAlertHexagon, TbAlertSquareRounded, TbBulb, TbInfoCircle, TbInfoTriangle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import './index.css';

export const ReactCallout = ({ node, updateAttributes }: any) => {
    const type = node.attrs.type || 'info';

    const { token, resolvedThemeName } = useAntDesignTheme();

    const ICONS: Record<string, ReactNode> = {
        default: (
            <TbAlertSquareRounded
                size='1.25rem'
                stroke={token.colorTextSecondary}
                fill={token.colorFillSecondary}
                onClick={() => updateAttributes({ type: 'info' })}
                style={{ cursor: 'pointer', transform: 'rotate(180deg)' }}
            />
        ),
        info: (
            <TbInfoCircle
                size='1.25rem'
                stroke={token.blue4}
                fill={token.blue1}
                onClick={() => updateAttributes({ type: 'warning' })}
                style={{ cursor: 'pointer' }}
            />
        ),
        warning: (
            <TbInfoTriangle
                size='1.25rem'
                stroke={token.gold5}
                fill={token.gold1}
                onClick={() => updateAttributes({ type: 'tip' })}
                style={{ cursor: 'pointer' }}
            />
        ),
        tip: (
            <TbBulb
                size='1.25rem'
                stroke={token.green4}
                fill={token.green1}
                onClick={() => updateAttributes({ type: 'danger' })}
                style={{ cursor: 'pointer' }}
            />
        ),
        danger: (
            <TbAlertHexagon
                size='1.25rem'
                stroke={token.red4}
                fill={token.red1}
                onClick={() => updateAttributes({ type: 'default' })}
                style={{ cursor: 'pointer' }}
            />
        ),
    };

    const typeToFontColor: Record<string, string> = {
        default: token.colorTextSecondary,
        info: token.blue4,
        warning: token.gold5,
        tip: token.green4,
        danger: token.red4,
    };

    return (
        <NodeViewWrapper
            className={`callout ${type} ${resolvedThemeName === 'dark' ? 'dark' : 'light'}`}
            style={{
                padding: '1rem',
                paddingBottom: 0,
                borderRadius: token.borderRadius,
                margin: '1rem 0',
            }}
        >
            <Row align='top' wrap={false}>
                <Col flex='none' className='callout-icon-column'>
                    <Flex className='callout-icon' align='center' justify='center'>
                        {ICONS[type]}
                    </Flex>
                </Col>
                <Col flex='auto' style={{ paddingLeft: '1rem' }}>
                    <div className='callout-content' style={{ flex: 1, color: typeToFontColor[type], fontWeight: 500 }}>
                        <NodeViewContent as='div' className='callout-node-view-content' />
                    </div>
                </Col>
            </Row>
        </NodeViewWrapper>
    );
};
